import {groupBy, orderBy} from 'lodash'

export default {
  methods: {
    filterByDepartment (items, dep) {
      return items.filter((item) => {
        const { position = [] } = item
        const [currentPosition = {}] = position
        const { department } = currentPosition
        return dep === department
      })
    },
    sortUsersByDepartment (items, dep) {
      const filterUsers = this.filterByDepartment(items, dep)
      const groupUsers = groupBy(filterUsers, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const usersSorted = orderBy(groupUsers.false, [item => item.username.toLowerCase()], ['asc'])
      return [...usersSorted, ...isNotAssigned]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/filterByDepartment.js